import axios from 'axios';
import { finances, slaves } from '../services/ApiService';
import { financesConstants } from '../constants/finances';
import { setSlavePaymentOrders } from '../actions/slaves';

export const setPaymentOrders = (paymentOrders = [], count = 0) => ({
  type: financesConstants.SET_PAYMENT_ORDERS_SUCCESS,
  count,
  paymentOrders,
});

export const startSetPaymentOrders = (params, isMember) => dispatch => {
  const request = !isMember ? finances.getPaymentOrders : slaves.getSlavePaymentOrders;
  const responseAction = !isMember ? setPaymentOrders : setSlavePaymentOrders;
  return request(params)
    .then((data = {}) => dispatch(responseAction(data.items, data.count)))
    .catch(err => dispatch({ type: financesConstants.SET_PAYMENT_ORDERS_FAILURE }));
};

export const startCreatePayments = (data, isMember) => dispatch => {
  const request = !isMember ? finances.createPayment : slaves.createSlavePayment;
  return request(data)
    .then(() => dispatch({ type: financesConstants.ADD_PAYMENTS_SUCCESS }))
    .catch(err =>
      dispatch({
        type: financesConstants.ADD_PAYMENTS_FAILURE,
        error: err.response.data.error.message.message,
        status: err.response.status,
        data: err.response.data,
      }),
    );
};

export const setPaymentsData = (data = [], count = 0) => ({
  type: financesConstants.SET_PAYMENTS_DATA_SUCCESS,
  data,
  count,
});

export const startSetPaymentsData = params => dispatch =>
  finances
    .getPaymentsData(params)
    .then((data = {}) => dispatch(setPaymentsData(data.items, data.count)))
    .catch(err => ({
      type: financesConstants.SET_PAYMENTS_DATA_FAILURE,
    }));

export const setHoldDetails = (details = {}) => ({
  type: financesConstants.SET_HOLD_DETAILS_SUCCESS,
  details,
});

export const startSetHoldDetails = (params, currencies) => dispatch => {
  const getHoldRequests = currencies.map(currency =>
    finances.getHoldDetails(params, currency.toLowerCase()),
  );

  return axios
    .all(getHoldRequests)
    .then((data = []) => {
      const holdDetails = {};
      data.forEach(details => {
        const currencyString = details[0];
        const { items, count, toPay = [] } = details[1];
        if (toPay) {
          const { sum, date } = toPay;
          const amount = sum;
          holdDetails[currencyString] = { items, count, amount, date };
        } else {
          const amount = null;
          const date = null;
          holdDetails[currencyString] = { items, count, amount, date };
        }
      });
      return dispatch(setHoldDetails(holdDetails));
    })
    .catch(err => {
      console.log(err);
      return { type: financesConstants.SET_HOLD_DETAILS_FAILURE };
    });
};

export const setHoldDetailsSettings = settings => ({
  type: financesConstants.SET_HOLD_DETAILS_SETTINGS_SUCCESS,
  settings,
});

export const startSetHoldDetailsSettings = currencies => dispatch => {
  const getHoldSettingsRequests = currencies.map(currency =>
    finances.getHoldDetailsSettings(currency.toLowerCase()),
  );

  return axios
    .all(getHoldSettingsRequests)
    .then(data => {
      const holdSettings = {};
      data.forEach(setting => {
        const currencyString = setting[0];
        const { flows, offers } = setting[1];
        holdSettings[currencyString] = { flows, offers };
      });
      return dispatch(setHoldDetailsSettings(holdSettings));
    })
    .catch(err => ({
      type: financesConstants.SET_HOLD_DETAILS_SETTINGS_FAILURE,
    }));
};

export const startCancelPayment = id => dispatch => {
  dispatch({ type: financesConstants.PAYMENT_CANCEL_REQUESTED });
  
  return finances
    .cancelPayment(id)
    .then(() => dispatch({ type: financesConstants.PAYMENT_CANCEL_SUCCESS }))
    .catch(err =>
      dispatch({
        type: financesConstants.PAYMENT_CANCEL_FAILURE,
        payload: err.response?.data?.error?.message ?? 'Error',
      }),
    );
};

export const clearError = () => ({ type: financesConstants.CLEAR_ERROR });

export const setRedirectToPaymentsData = data => ({
  type: financesConstants.REDIRECT_TO_PAYMENTS_DATA,
  data,
});

export const clearRedirectToPaymentsData = () => ({
  type: financesConstants.CLEAR_REDIRECT_TO_PAYMENTS_DATA,
});
